import { type AppLocale, SiteFooter, type SiteFooterLink } from "@tessel/ui"
import { useI18n } from "@/i18n"

/**
 * Landing-page footer. Wraps the shared SiteFooter so tessel.app participates
 * in the same logo + link cluster + copyright pattern as community, support
 * and blog. Uses the existing `footer.*` translation keys so copy doesn't
 * change at rollout.
 */
export const WebsiteFooter = () => {
  const { t, language, setLanguage } = useI18n()

  const links: SiteFooterLink[] = [
    { label: t("footer.terms"), href: "/legal" },
    { label: t("footer.privacy"), href: "/privacy" },
    { label: t("footer.contact"), href: "/contact" },
  ]

  const onLocaleChange = (locale: AppLocale) => {
    setLanguage(locale as AppLocale)
  }

  return (
    <SiteFooter
      homeHref="/"
      logoAlt={t("logo.alt")}
      logoLightSrc="/logo-light.png"
      logoDarkSrc="/logo-dark.png"
      links={links}
      note={t("footer.copyright")}
      locale={language as AppLocale}
      onLocaleChange={onLocaleChange}
    />
  )
}
